import { createFeatureActionNamer } from '../../../redux/action-name';

const getActionName = createFeatureActionNamer('directive');

export const ADD_KEY_TAX_DIRECTIVE = getActionName('ADD_KEY_TAX_DIRECTIVE');
export const UPDATE_KEY_TAX_DIRECTIVE = getActionName('UPDATE_KEY_TAX_DIRECTIVE');
